import type { AuditLogEntity } from '../../domain/entities/AuditLogEntity.js';
import type { AuditLogListOptions, IAuditLogRepository } from '../../domain/repositories/IAuditLogRepository.js';
import { AuditLogRemoteDataSource } from '../datasources/AuditLogRemoteDataSource.js';
import type { AuditLogDto } from '../dtos/AuditLogDto.js';

function mapDto(dto: AuditLogDto): AuditLogEntity {
  return {
    id: dto.id,
    orgId: dto.org_id,
    projectId: dto.project_id,
    locationId: dto.location_id,
    sessionId: dto.session_id,
    tableName: dto.table_name,
    op: dto.op,
    rowPk: dto.row_pk,
    actorId: dto.actor_id,
    oldData: dto.old_data,
    logMessage: dto.log_message,
    metadatas: dto.metadatas ?? {},
    changedAt: dto.changed_at,
  };
}

export class AuditLogRepository implements IAuditLogRepository {
  constructor(private readonly ds: AuditLogRemoteDataSource) {}

  async list(options: AuditLogListOptions) {
    const { data, estimatedTotal, hasNext, nextPage } = await this.ds.list(options);
    return {
      data: data.map(mapDto),
      estimatedTotal,
      hasNext,
      ...(nextPage ? { nextPage: { data: nextPage.data.map(mapDto), hasNext: nextPage.hasNext } } : {}),
    };
  }
}
